export const routes = [
  {
    path: "/inscricao/auth/dashboard",
    component: () => import("./components/dashboard"),
    name: "inscricao.dashboard",
    meta: {
      requiresAuth: true,
    },
  },
];
